<template>
  <div class="sitemap">
    <ba-sitemap />
  </div>
</template>

<script>
import BaSitemap from '@/components/sitemap/Pane'

export default {
  name: 'Sitemap',
  components: {
    BaSitemap
  }
}
</script>

<style lang="scss" scoped>
.sitemap {
}
</style>
